__turbopack_context__.v({
  "horizontal": "_2yEGEG_horizontal",
  "vertical": "_2yEGEG_vertical",
});
